import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import React from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';

export const CloseButton = ({
	onClick,
	className = '',
	ariaLabel = 'Close button.',
	segmentvalue = 'close',
	dataqa = '',
}) => {
	const handleClick = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'button',
				field_name_dataqa: `${dataqa}`,
				field_value: segmentvalue,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (isFunction(onClick)) {
			onClick(e);
		}
	};

	return (
		<button
			type="button"
			className={`close-button ${className}`.trim()}
			onClick={handleClick}
			aria-label={ariaLabel}
			dataqa={dataqa}
		>
			<i className="close-icon" aria-hidden="true" />
		</button>
	);
};

CloseButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	className: PropTypes.string,
	ariaLabel: PropTypes.string,
	segmentvalue: PropTypes.string,
	dataqa: PropTypes.string,
};

export default CloseButton;
